import throttle from "lodash/throttle";

import {
	OKEVENT,

	triggerOkEvent,
} from "shared/util/OkEventHelpers";
import {
	PERSIST_DRAFT_THROTTLE,
	PERSIST_MESSENGER_STATE_THROTTLE,
} from "apps/messenger/util/consts";
import OkC from "shared/util/OkcApi";

// Get messenger state.
export function getMessengerState() {
	return OkC.get("/messages/global_messaging/state", {
		api: 1,
	});
}

// Update messenger state.
export function setMessengerState(data) {
	return OkC.post("/messages/global_messaging/state", {
		api: 1,
		data,
	});
}

// Export throttled version of this function.
export const throttledSetMessengerState = throttle(
	setMessengerState, PERSIST_MESSENGER_STATE_THROTTLE, { leading: true },
);

// Get unread count.
export function getBadgeCount() {
	return OkC.api("/profile/me/gns_counts", {
		api: 1,
	});
}

// Load a conversation.
export function getConversation({ userid, limit }) {
	return OkC.get(`/messages/conversations/${userid}`, {
		api: 1,
		version: 2,
		data: {
			limit,
		},
	});
}

// Delete a conversation.
export function deleteConversation({ userid }) {
	return OkC.post(`messages/conversations/${userid}/delete`, {
		api: 1,
	}).then((res) => {
		triggerOkEvent(OKEVENT.DeleteConversation, {
			userid,
			source: "global_messenger",
		});

		return res;
	});
}

// Load messages for a conversation.
export function getMessages({ userid, limit, before, after }) {
	return OkC.get(`/messages/conversations/${userid}`, {
		api: 1,
		version: 2,
		data: {
			limit,
			before,
			after,
		},
	});
}

// Send a message
export function sendMessage(data) {
	const {
		senderid,
		receiverid,
		body,
		profile_comment: profileComment,
		source,
		service,
	} = data;

	return OkC.post("/messages/send", {
		api: 1,
		data: {
			receiverid,
			body,
			profile_comment: profileComment,

			source,
			service,
		},
	}).then((res) => {
		triggerOkEvent(OKEVENT.SentMessage, {
			tuid: senderid,
			from: senderid,
			to: receiverid,
			msgid: res.msgid,
			body,
		});

		return res;
	});
}

// Mark a message as read.
export function markMessageRead({ userid, msgid }) {
	return OkC.post(`/messages/conversations/${userid}/read`, {
		api: 1,
		data: {
			msgid,
		},
	}).then((res) => {
		triggerOkEvent(OKEVENT.ReadMessage, {
			msgid,
			userid,
		});

		return res;
	});
}

// Cancel the content warning.
export function cancelContentWarning({ userid }) {
	return OkC.post(`/profile/${userid}/unreport`, {
		api: 1,
		data: {
			type: "message",
		},
	});
}

// Save a message draft.
export function saveMessageDraft({ userid, message, profileComment }) {
	return OkC.post("/messages/draft", {
		api: 1,
		data: {
			receiverid: userid,
			body: message,
			profile_comment: profileComment,
		},
	}).then((res) => {
		triggerOkEvent(OKEVENT.SaveMessageDraft, {
			userid,
			draft: message,
		});

		return res;
	});
}

// Export throttled version of this function.
const _throttleSaveMessageDraft = throttle((resolve, reject, args) => {
	saveMessageDraft(...args).then(resolve).catch(reject);
}, PERSIST_DRAFT_THROTTLE, { trailing: true });

export function throttleSaveMessageDraft(...args) {
	return new Promise((resolve, reject) => {
		_throttleSaveMessageDraft(resolve, reject, args);
	});
}

// Get the throttled save draft (for cancellation).
export function getThrottledSaveMessageDraft() {
	return _throttleSaveMessageDraft;
}

// Delete a message draft.
export function deleteMessageDraft({ userid }) {
	return OkC.delete("/messages/draft", {
		api: 1,
		data: {
			receiverid: userid,
		},
	}).then((res) => {
		triggerOkEvent(OKEVENT.SaveMessageDraft, {
			userid,
			draft: null,
		});

		return res;
	});
}

// Delete a message draft.
export function startSMSForwarding(matchUserId) {
	return OkC.post("/oksms/sms_forwarding/start", {
		api: 1,
		data: {
			matchUserId,
		},
	});
}

export function graduateMessagePledge() {
	return OkC.post("/user_guides/message_pledge/understands", {
		api: 1,
	});
}



// WEBPACK FOOTER //
// ./src/apps/messenger/util/web.js